import { combineReducers } from 'redux';

import myFavoritesReducer from './myFavorites.reducer';

const Reducers = combineReducers({
  myFavorites: myFavoritesReducer
});

export default Reducers;
